import { FC } from 'react'
import Link from 'next/link'
import IconRuStore from '@icons/footer-apps-ru-store.svg'
import IconApk from '@icons/footer-apps-apk.svg'

import s from '@widgets/Common/Footer/Footer.module.sass'

const srcRuStore =
  'https://apps.rustore.ru/app/ru.afisha.android?referrer=appmetrica_tracking_id%3D316607329581741903%26ym_tracking_id%3D9754951547239727150'
const srcApk =
  'https://www.afisha.ru/article/kak-ustanovit-afishu-na-android/?referrer=appmetrica_tracking_id%3D28376954520536502%26ym_tracking_id%3D6348018801305690714'
// const srcAppStore =
//   'https://apps.apple.com/ru/app/afisha-original/id6449671760?referrer=appmetrica_tracking_id%3D100434862846010941%26ym_tracking_id%3D4036302963600852144'

export const FooterApps: FC = () => (
  <div className={s.apps}>
    {/* RuStore */}
    <Link href={srcRuStore} className={s['app-link']} target='_blank'>
      <IconRuStore />
    </Link>
    {/* Apk */}
    <Link href={srcApk} className={s['app-link']} target='_blank'>
      <IconApk />
    </Link>
  </div>
)
